export default __webpack_public_path__ + "public/assets/images/030cd8e78d5576329ea9c2a7276544f7.png";